import get from 'lodash.get';
import config from 'Config/config.json';

export const getRightSideAdConfig = (adCount) => {
  const adConfig = get(config, 'ads.slot-2');

  return {
    type: 'DESKTOP_SIDE_ADVERT',
    props: {
      label: 'Advertisement',
      id: `refresh-right_${adCount}`,
      extraClassNames: { '-sidebar-ad': true },
      targeting: {
        position: `right_${adCount}`,
        placement: `right_${adCount}`,
        refresh: 'yes',
      },
      type: 'slot-2',
      targetViewport: 'desktop',
      ...adConfig,
    },
  };
};
